import React, { useState, useEffect } from "react";
import MainButton from "../../shared/Button";
import borderBack from "../../../assets/images/borderBack.png";
import AuthLayout from "./AuthLayout";
import { Formik, Form, Field } from "formik";
import AuthInput from "../../shared/authinput";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import FormMainLayouts from "../../layouts/FormMainLayouts";
import { PRICEPLAN, USERINFO } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
import { BusinessCustomervalidation } from "../../../helpers/validations/Auth";
import {
  Header,
  Linked,
  Maincontant,
  PaymentFrequencyMain,
  StyledRadioMain,
  ErrorSpan,
} from "./styles/BusinessCustomerStyls";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "../../../redux/slice/user/UserSlice";

const BusinessCustomer = () => {
  const UserInformation = useSelector((state) => state.auth);
  const [Loading, setLoading] = useState(false);
  const [BtnLoading, setBtnLoading] = useState(false);
  const navigate = useNavigate();
  const [PaymentFrequency, setPaymentFrequency] = useState([]);
  const dispatch = useDispatch();

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setBtnLoading(true);
      const resp = await httpRequest.patch(USERINFO, {
        user: {
          company_name: values.CompanyName,
          price_plan_id: values.paymentFrequency,
          user_type: "business",
        },
      });
      resetForm();
      if (resp?.status === 200) {
        const userToken = { auth_token: UserInformation?.user?.auth_token };
        const UserData = { ...resp?.data?.user, ...userToken };
        dispatch(loginSuccess(UserData));
        if (resp?.data?.user.status === "pending") {
          navigate("/pending-appproval");
        }
      }
      setBtnLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setBtnLoading(false);
    }
  };

  useEffect(() => {
    GetPricePlan();
  }, []);

  const GetPricePlan = async () => {
    try {
      setLoading(true);
      const resp = await httpRequest.get(PRICEPLAN);
      if (resp?.status === 200) {
        if (resp?.data?.message === "Success") {
          setPaymentFrequency(resp?.data?.data);
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    }
  };

  return (
    <>
      <Container maxWidth="lg">
        <AuthLayout arrow={true}>
          <Header>
            <Linked to="/customer-type">
              <img src={borderBack} alt="Linkarrow" />
            </Linked>
            <Maincontant>
              <h6>Business Customer</h6>
              <p>Please add your company and select the payment frequency</p>
            </Maincontant>
          </Header>

          <FormMainLayouts>
            <Formik
              initialValues={{ CompanyName: "", paymentFrequency: "" }}
              validationSchema={BusinessCustomervalidation}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form autocomplete="off">
                  <Field
                    type="text"
                    name="CompanyName"
                    label="Company Name"
                    component={AuthInput}
                    placeholder="Enter your company name"
                  />

                  {Loading && "Loading..."}
                  {!Loading && (
                    <>
                      <PaymentFrequencyMain>
                        <h6>Payment Frequency</h6>
                        <StyledRadioMain>
                          {PaymentFrequency &&
                            PaymentFrequency.length > 0 &&
                            PaymentFrequency?.map((value) => {
                              return (
                                <>
                                  <label
                                    className="container"
                                    key={value?.name}
                                  >
                                    {value?.name} ( {value?.interval} Days)
                                    <input
                                      type="radio"
                                      name="paymentFrequency"
                                      value={value?.id}
                                      onChange={formik.handleChange}
                                      checked={
                                        formik.values.paymentFrequency ===
                                        value?.id.toString()
                                      }
                                    />
                                    <span className="checkmark">
                                      <CheckIcon className="icon" />
                                    </span>
                                  </label>
                                </>
                              );
                            })}
                        </StyledRadioMain>

                        {formik.touched.paymentFrequency &&
                          formik.errors.paymentFrequency && (
                            <ErrorSpan>
                              {formik.errors.paymentFrequency}
                            </ErrorSpan>
                          )}
                      </PaymentFrequencyMain>
                    </>
                  )}

                  <MainButton
                    type="submit"
                    label="Continue"
                    isLoading={BtnLoading}
                  />
                </Form>
              )}
            </Formik>
          </FormMainLayouts>
        </AuthLayout>
      </Container>
    </>
  );
};

export default BusinessCustomer;
